import styled, { css } from 'styled-components'
import { Font12, Font14, Regular } from 'components/Typography'
import theme from 'theme_'
import { Link } from 'react-router-dom'
import { WhiteBlock } from 'components/Layout'
import { HomeLicensesCopyCode } from 'features/home/components/HomeLicensing/AvailableLicenses/HomeLicensesGroupsTable/HomeLicensesGroup/styles'

export const StyledNoLicenses = styled(Regular)`
  display: flex;
  flex-direction: row;
  height: 64px;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: ${theme.colors.disabledGrey};
`

export const LicenseCellStyles = css`
  ${Font12};
  word-break: break-word;
`

export const StyledLicenseLink = styled(Link)`
  color: ${theme.colors.horizonOrange};
  word-break: break-all;
  text-decoration: none;
  &:hover,
  :active,
  :focus {
    text-decoration: underline;
  }
`

export const LicensesUsedCodesMobileContainer = styled(WhiteBlock)`
  width: 100%;
  gap: ${theme.spacing.base};
  ${Font14}
`

export const LicensesAvailableCodesMobileContainer = styled(
  LicensesUsedCodesMobileContainer
)``
export const LicensesMobileCopyCodeWrapper = styled(HomeLicensesCopyCode)`
  flex-direction: column;
`

export const LicensesAvailableCodesMobileHeader = styled.div`
  display: flex;
`
